module.exports = __webpack_public_path__ + "img/schoolDataScreenbg.817e662b.png";